<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 8.5V8C4 5.79086 5.79086 4 8 4H15.5C17.7091 4 19.5 5.79086 19.5 8V16C19.5 18.2091 17.7091 20 15.5 20H8C5.79086 20 4 18.2091 4 16V16"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M13.4419 12.4419C13.686 12.1979 13.686 11.8021 13.4419 11.5581L9.46447 7.58058C9.22039 7.3365 8.82466 7.3365 8.58058 7.58058C8.3365 7.82466 8.3365 8.22039 8.58058 8.46447L12.1161 12L8.58058 15.5355C8.3365 15.7796 8.3365 16.1753 8.58058 16.4194C8.82466 16.6635 9.22039 16.6635 9.46447 16.4194L13.4419 12.4419ZM3 12.625H13V11.375H3V12.625Z"
      fill="currentColor"
    />
  </svg>
</template>
